export default __webpack_public_path__ + "static/media/ace_of_wands.8cd355bd.png";